import styled from '@emotion/styled';
import {TableCell, TableRow} from '@bosch/react-frok';

export const ItemEntryRow = styled(TableRow)`
    td {
    }

    &:hover {
        > td {
            background-color: var(--plain__enabled__fill__hovered);
        }
    }
`;

export const ActionsCell = styled(TableCell)`
    text-align: right;
    min-width: 6rem;
`;

export const TitleCell = styled(TableCell)`
    max-width: 15rem;
    min-width: 100px;
    overflow-wrap: anywhere;
`;

export const Title = styled.div`
    line-height: 1.3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
`;
